import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent implements OnInit {

  constructor(private apiService: ApiService) { }

  formNewsLetter!: FormGroup;

  anno: string = new Date().getFullYear().toString();
  newsletter: string = '';
  carnetAttivo: boolean = false;

  ngOnInit(): void {

    this.formNewsLetter = new FormGroup({
      email: new FormControl(null, [Validators.required, Validators.email])
    })

    this.apiService.getCarnetInfo().subscribe({
      next: (data) => this.carnetAttivo = !!data?.attivo,
      error: () => this.carnetAttivo = false
    })
  }

  onSubmit() {
    if (this.formNewsLetter.valid) {
      this.apiService.addNewsletter({ email: this.formNewsLetter.get('email')?.value }).subscribe({
        next: (data) => { },
        error: (err) => {
          //this.apiService.message('error', 'Errore', err.error.message.message);
          this.newsletter = err.error.message.message;
        },
        complete: () => {
          /* this.apiService.message('success', 'Successo', 'Iscrizione alla NewsLetter effettuata con successo!') */
          this.newsletter = "Iscrizione effettuata con successo. Grazie!"
          setTimeout(
            () => {
              this.newsletter = '';
              this.formNewsLetter.reset();
              this.formNewsLetter.markAsUntouched();
              this.formNewsLetter.markAsPristine();
            }, 10000
          )
        }
      })
    }

  }
}
